import { Icon } from "./Icon.tsx";

export type NewItemsPillProps = {
  /** "3 new". */
  label: string;
  /** Jumps to the top of the list. */
  onPress: () => void;
  testID?: string;
};

/**
 * Stands for rows that arrived above where I've scrolled to (Gmail's, Slack's "new messages"). Goes first in a
 * ScrollView: it takes no room, and stays at the top of the view. iOS and Android: an accent pill over the list.
 */
export function NewItemsPill({ label, onPress, testID }: NewItemsPillProps) {
  return (
    <div className="b-new-pill-rail">
      <button type="button" className="b-new-pill" onClick={onPress} data-testid={testID}>
        <Icon name="arrowUp" size="icon.sm" color="accent.fg" />
        {label}
      </button>
    </div>
  );
}
